import store from "@/store/store";
import { camelCase } from "lodash";

export class ConfigurationValidator {
  static validate(validators, model, params = []) {
    let permissions = store.state.Auth.user.firm.permissions || [];

    permissions = permissions.reduce((accumulator, permission) => {
      if (validators.includes(permission.name)) {
        accumulator.push(permission.name);
      }
      return accumulator;
    }, []);

    for (let x = 0; x < permissions.length; x++) {
      const func = camelCase(permissions[x]);

      if (this[func]) {
        if (!this[func](model, params)) {
          return false;
        }
      }
    }

    return true;
  }

  static mustBelongToSameFirm(model) {
    return model.firm.id === store.state.Auth.user.firm.id;
  }

  static mustBeAllowedStatus(model, params) {
    return (
      params.allowedStatuses && params.allowedStatuses.includes(model.status)
    );
  }

  static mustCompleteAllOperations(order) {
    for (let x = 0; x < order.operations.length; x++) {
      if (order.operations[x].status !== "COMPLETED") {
        return false;
      }
    }

    return true;
  }

  static mustHaveClaimDeclaration(model) {
    return model.claimLines.length > 0;
  }

  static mustHaveAssetDeclaration(operation) {
    return !!(
      operation.asset ||
      operation.locationId ||
      operation.noAsset === "X"
    );
  }

  static mustHaveSummaryCodes(operation) {
    return !!(
      (operation.failureCode && operation.repairCode) ||
      (operation.outcomeCode && operation.responsibilityCode)
    );
  }
}



// WEBPACK FOOTER //
// ./src/helpers/ConfigurationValidator.js